import type { SVGProps } from 'react';

/** Solid drop matching the mark in the ORBCoN wordmark. Fill with `text-accent`. */
export default function BloodDropIcon({ className = '', ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      className={className}
      {...props}
    >
      <path d="M12 1.25C8.2 7.4 4.8 12.8 4.8 16.6 4.8 20.6 8 22.75 12 22.75s7.2-2.15 7.2-6.15C19.2 12.8 15.8 7.4 12 1.25z" />
    </svg>
  );
}
